import {CONSONANT_VOWEL_PAIRS_M} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_m";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_M_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_M} title="Consonant-Vowel Pairs: ㅁ (m)" />
     </>
);}